
import { RevAccordionItem } from '@ds/components/Accordion'
import { RevLink } from '@ds/components/Link'

import FormattedMessage from '@i18n/components/FormattedMessage'

export default {
  components: {
    FormattedMessage,
    RevAccordionItem,
    RevLink,
  },
  props: {
    answers: {
      type: Array,
      required: true,
    },
    question: {
      type: Object,
      required: true,
    },
  },
}
